module.exports = __webpack_public_path__ + "static/Burst_7-814e773f7f2ba67a58db3d46fcafb661.jpg";